<mat-form-field
  class="mat-block"
  [ngClass]="{'l-updated-field': ctrlBaseCurrency.value?.isOverride == true && !isOrgNode}"
>
  <mat-select
    id="ddBaseCurrency"
    [compareWith]="compareCurrencies"
    [formControl]="ctrlBaseCurrency"
    [placeholder]="placeholder"
    [required]="ctrlBaseCurrency.hasError('required')"
  >
    <mat-option *ngFor="let currency of currencyList" [value]="currency">
      {{currency.name + ' ' + currency.symbol}}
    </mat-option>
  </mat-select>
  <mat-error
    id="errBaseCurrency"
    class="error-message"
    *ngIf="ctrlBaseCurrency.hasError('required') &&
     (ctrlBaseCurrency.dirty ||ctrlBaseCurrency.touched)"
  >
    {{ "organization.create.section_3.base_currency_required" | translate }}
  </mat-error>
</mat-form-field>
